import { createBrowserHistory } from 'history';

export const push = (path: string) => {
  const history = createBrowserHistory();
  history.push(path);
};

export default { push };
